import { AllowedCallTypes, MakeActionCreator } from "../../common/const";
import { makeApiStateReducer } from "../../common/reducers/apiState";

const makeUpdateStateReducer = ({
  name,
  path = "seneca/",
  idFieldName
}: MakeActionCreator) => {
  return makeApiStateReducer({
    name,
    path,
    idFieldName,
    callType: AllowedCallTypes.UPDATE
  });
};

export default makeUpdateStateReducer;
